import { render } from "./CreateNew.vue?vue&type=template&id=1ebb371c&scoped=true"
import script from "./CreateNew.vue?vue&type=script&lang=js"
export * from "./CreateNew.vue?vue&type=script&lang=js"

import "./CreateNew.vue?vue&type=style&index=0&id=1ebb371c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebb371c"]])

export default __exports__